import { render, staticRenderFns } from "./LevelPills.vue?vue&type=template&id=0faedc14&scoped=true&"
import script from "./LevelPills.vue?vue&type=script&lang=js&"
export * from "./LevelPills.vue?vue&type=script&lang=js&"
import style0 from "./LevelPills.vue?vue&type=style&index=0&id=0faedc14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faedc14",
  null
  
)

export default component.exports